import { oz } from '@weft/utils';

export const CursorSchema = oz.string().optional();